// extracted by mini-css-extract-plugin
export var link = "integration-card-module--link--c8e4e";
export var linkIcon = "integration-card-module--linkIcon--39f7c";
export var logo = "integration-card-module--logo--a7af6";
export var root = "integration-card-module--root--40ecc";